export const unique = <T>(val: T[], ...toAdd: T[]): T[] => [
  ...new Set(val.concat(toAdd))
]
